export const UPDATE_FREQUENCY_CAP_TEXT = {
  HEADER: 'Update frequency cap?',
  DESCRIPTION:
    'Limit the number of campaigns that a user can receive from this message type. Once the frequency cap is met for the period we will skip any additional sends.',
  ACTION_BUTTON: 'Save',
  SUCCESS_MESSAGE: 'Success! Updated Frequency Cap:',
  ERROR_MESSAGE: 'Unable to update frequency cap.',
  MODAL_ID: 'update-frequency-cap-modal',
};

export const FIELDS = {
  frequencyCapOption: 'frequencyCapOption',
  numMessagesInPeriod: 'numMessagesInPeriod',
  period: 'period',
};
